/* eslint-disable no-unused-vars */
import Player from '@vimeo/player';

export default {
  init() {
    // JavaScript to be fired on all pages
    function getVimeoThumbUrl(vimeoId) {
      var deferred = $.Deferred();
      $.get('https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/' + vimeoId, (data) => {
        const img_url = data.thumbnail_url;
        const img = img_url.split('_');
        deferred.resolve(img[0] + '.jpg');
      });
      return deferred;
    }

    const $body = $('body'),
          $imgVideos = $('.img-video'),
          vimeos = '.img-video iframe',
          nativeVideoPlay = '.img-video.video-native .img-container',
          iframeVideoPlay = '.img-video.video-iframe .img-container';

    $imgVideos.each((i, imgVideo) => {
      const $imgVideo = $(imgVideo),
            $nativeVideo = $imgVideo.find('video'),
            $iframeVideo = $imgVideo.find('iframe'),
            $imgVideoThumb = $imgVideo.find('.img'),
            hasNativeVideo = ($nativeVideo.length > 0) ? true : false,
            hasIframeVideo = ($iframeVideo.length > 0) ? true : false,
            hasVideo = (hasNativeVideo || hasIframeVideo) ? true : false;

      let $video;

      if (hasVideo) {
        $imgVideo.addClass('video ratio_16_9');
      }

      if (hasNativeVideo) {
        $video = $imgVideo.find('video');
        $imgVideo.addClass('video-native');
      }

      if (hasIframeVideo) {
        $video = $imgVideo.find('iframe');
        $imgVideo.addClass('video-iframe');
        if ($iframeVideo.hasClass('type-vimeo')) {
          $imgVideo.addClass('video-vimeo');
        }
        if ($iframeVideo.hasClass('type-youtube')) {
          $imgVideo.addClass('video-youtube');
        }
      }

      if ($imgVideo.data('video-url')) {
        const vimeoVideoUrl = $imgVideo.data('video-url');
        const match = /vimeo.*\/(\d+)/i.exec(vimeoVideoUrl);
        if (match) {
          const vimeoVideoID = match[1];
          getVimeoThumbUrl(vimeoVideoID)
            .done((img) => {
              // $imgVideo.css({
              //   'background-image' : 'url("' + img + '")',
              // });
              $imgVideoThumb.css({
                'background-image' : 'url("' + img + '")',
              });
              // $imgVideoThumb.attr('src', img);
            });
        }
      }

      if ($imgVideo.hasClass('video-playonce')) {
        if (hasIframeVideo) {
          const $video = $imgVideo.find('iframe'),
                options = {
                  loop: false,
                },
                vimeoPlayer = new Player($video, options);

          if ($imgVideo.hasClass('video-playing')) {
            vimeoPlayer.pause().then(() => {
              // the video was played
            }).catch((error) => {
                $imgVideo.removeClass('video-playing');
                console.log(error);
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;

                    case 'PrivacyError':
                        // the video is private
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            });
            $imgVideo.removeClass('video-playing');
          } else {
            $imgVideo.addClass('video-playing');
            vimeoPlayer.play().then(() => {
                // the video was played
            }).catch((error) => {
                $imgVideo.removeClass('video-playing');
                console.log(error);
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;

                    case 'PrivacyError':
                        // the video is private
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            });
          }

          vimeoPlayer.on('ended', (data) => {
            $imgVideo.removeClass('video-playing');
            vimeoPlayer.unload().then(() => {
                // the video was unloaded
            }).catch((error) => {
                // an error occurred
            });
          });
        }
      }
    });

    if ($body.hasClass('init-video')) {
      $body.removeClass('init-video');

      $('body').on('click', nativeVideoPlay, (e) => {
        const $imgVideo = $(e.target).closest('.img-video'),
              $video = $imgVideo.find('video');

        if ($imgVideo.hasClass('video-playing')) {
          $video.get(0).pause();
          $imgVideo.removeClass('video-playing');
        } else {
          $imgVideo.addClass('video-playing');
          $video.get(0).play();
        }
      });

      $('body').on('click', iframeVideoPlay, (e) => {
        const $imgVideo = $(e.target).closest('.img-video'),
              $video = $imgVideo.find('iframe');

        if ($imgVideo.hasClass('video-vimeo')) {
          const options = {
                  loop: false,
                },
                vimeoPlayer = new Player($video, options);

          if ($imgVideo.hasClass('video-playing')) {
            vimeoPlayer.pause().then(() => {
              // the video was played
            }).catch((error) => {
                $imgVideo.removeClass('video-playing');
                console.log(error);
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;

                    case 'PrivacyError':
                        // the video is private
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            });
            $imgVideo.removeClass('video-playing');
          } else {
            $imgVideo.addClass('video-playing');
            vimeoPlayer.play().then(() => {
                // the video was played
            }).catch((error) => {
                $imgVideo.removeClass('video-playing');
                console.log(error);
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;

                    case 'PrivacyError':
                        // the video is private
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            });
          }

          vimeoPlayer.on('ended', (data) => {
            $imgVideo.removeClass('video-playing');
            vimeoPlayer.unload().then(() => {
                // the video was unloaded
            }).catch((error) => {
                // an error occurred
            });
          });
        }

        if ($imgVideo.hasClass('video-youtube')) {
          $imgVideo.addClass('video-playing');
          $video[0].src += '?autoplay=1';
        }
      });

      $('video').on('ended', (e) => {
        const $imgVideo = $(e.target).closest('.img-video');
        $imgVideo.removeClass('video-playing');
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/components/video.js